//이메일 전송내역 팝업
<template>
	<sf-modal-layout size="m" :title="getMessage_('QWCC001903')" :show="show" :closeModal="close">
		<div class="sf-col sf-col-4">
			<sf-card class="p-0 h-100 card_bg">
				<div class="sf-search-layout__body__container">
					<sf-search-layout>
						<el-row :gutter="20">
							<!-- 차기교정기간 -->
							<el-col :span="12">
								<div class="sf-input-group-wrapper">
									<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001547') }}</span>
									<el-date-picker
										v-model="searchDateRange"
										type="daterange"
										align="right"
										:start-placeholder="getMessage_('QWCC000920')"
										:end-placeholder="getMessage_('QWCC000954')"
										range-separator="~"
									/>
								</div>
							</el-col>
						</el-row>
						<template slot="button">
							<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
								{{ getButtonMsg_(scrId, 'CR') }}
							</sf-button>
						</template>
					</sf-search-layout>
				</div>
			</sf-card>
		</div>
		<div class="sf-col sf-col-10">
			<sf-card class="p-0 border-0 bg-transparent h-100">
				<sf-data-table
					ref="popupTable"
					:pageUnit="emlPagingInfo.pageUnit"
					:totalSize="emlPagingInfo.totalSize"
					paging
					:columns="columns"
					:rows="emlResultList"
					height="50vh"
					index
					fit="fit"
					:stripe="false"
					:excel="isButton_(scrId, 'EX')"
					@changedPage="changedPage"
				>
				</sf-data-table>
			</sf-card>
		</div>
	</sf-modal-layout>
</template>

<script>
import { serviceComputed, serviceMethods } from '@mmc/mmcm/MesInfm/store/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			show: false,
			mesEqipNo: '',
			searchDateRange: [this.$moment().startOf('year').format('YYYY-MM-DD'), this.$moment().endOf('year').format('YYYY-MM-DD')]
		};
	},
	async created() {
		await this.getCommCodes_({ key: 'sndStCdList', codeType: 'SND_ST' }); //발송상태;
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		open(mesEqipNo) {
			this.show = true;
			this.searchDateRange = [this.$moment().startOf('year').format('YYYY-MM-DD'), this.$moment().endOf('year').format('YYYY-MM-DD')];
			this.mesEqipNo = mesEqipNo;
			this.searchList();
		},
		close() {
			this.refresh();
			this.show = false;
		},
		refresh() {
			this.setState_({ key: 'emlResultList', value: [] });
			this.$emit('Refresh');
		},
		async searchList() {
			try {
				this.$sf_toggleLoading(true);
				const strDt = this.searchDateRange[0] && this.$moment(this.searchDateRange[0]).format('YYYYMMDD');
				const endDt = this.searchDateRange[1] && this.$moment(this.searchDateRange[1]).format('YYYYMMDD');
				await this.getEmlList_({ strDt, endDt, mesEqipNo: this.mesEqipNo });
			} catch (error) {
				this.$sf_toast({
					type: 'error',
					message: error?.message
				});
			} finally {
				this.$sf_toggleLoading(false);
			}
		},

		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setEmlPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setEmlPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh');
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			return [
				{
					label: this.getMessage_('QWCC001317'), //관리번호
					prop: 'mesEqipNo',
					minWidth: '1px'
				},
				{
					label: this.getMessage_('QWCC001552'), //발송일시
					prop: 'emlSndDd'
				},
				{
					label: this.getMessage_('QWCC001263'), //발신자
					prop: 'dsprNm'
				},
				{
					label: this.getMessage_('QWCC001257'), //수신자
					prop: 'rcptNm'
				},
				{
					label: this.getMessage_('QWCC001577'), //발송상태
					prop: 'sndStCd',
					form: {
						type: 'select',
						options: this.sndStCdList,
						isDisabled: () => true // 에디트 방지
					}
				}
			];
		}
	},
	watch: {
		searchDateRange(newValue) {
			if (newValue == null) {
				this.searchDateRange = ['', ''];
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.sf-button.sf-line-default {
	min-width: fit-content;
}
</style>
